import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

import { FormSubmitHandler } from 'Elements/Form';

import FilterSurfaces from './FilterSurfaces';
import { initialValues, Schema as SurfaceParamsSchema } from './schema';
import SurfacesTable from './SurfacesTable';

const Height100 = styled.div`
  height: 100%;
`;
const Width100 = styled.div`
  width: 100%;
  max-width: 250px;
`;

export default function Surfaces() {
  const [params, setParams] = useState(serialize(
    initialValues
  ) as SurfaceParamsSchema);

  const onSubmit: FormSubmitHandler<SurfaceParamsSchema> = values => {
    setParams(serialize(values));
  };

  return (
    <Grid container direction="row" component={Height100}>
      <Grid item xs component={Width100}>
        <FilterSurfaces onSubmit={onSubmit} />
      </Grid>

      <Grid item sm={12} md={8} component={Height100}>
        <SurfacesTable params={params} />
      </Grid>
    </Grid>
  );
}

const serialize = (values: any): any => {
  const params = JSON.parse(JSON.stringify(values));

  params.targets = [];
  if (params.over_target) params.targets.push(1);
  if (params.reaching_target) params.targets.push(0);
  if (params.below_target) params.targets.push(-1);

  delete params.over_target;
  delete params.reaching_target;
  delete params.below_target;

  params.start_at = params.range.start_at;
  params.end_at = params.range.end_at;

  delete params.range;

  return params;
};
